/* YouPlus Redesign — scroll reveal (作業用テーマ, 2026-07-15)
   セクション見出しと商品/コレクションカードに data-scroll-reveal を付与し、
   ビューポートに入ったタイミングでフェードイン+わずかな上昇アニメーションを行う。
   IntersectionObserver未対応環境ではアニメーションなしで即表示する。 */
(function () {
  'use strict';

  function markTargets() {
    var selectors = [
      '.title-wrapper-with-link',
      '.card-wrapper'
    ];
    var targets = document.querySelectorAll(selectors.join(', '));
    targets.forEach(function (el) {
      if (!el.hasAttribute('data-scroll-reveal')) {
        el.setAttribute('data-scroll-reveal', '');
      }
    });
  }

  function init() {
    markTargets();

    var targets = document.querySelectorAll('[data-scroll-reveal]');

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
